import { render, staticRenderFns } from "./StatisticModal.vue?vue&type=template&id=7e0b2475"
import script from "./StatisticModal.vue?vue&type=script&lang=js"
export * from "./StatisticModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports